import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://67ad7ad6ea234e7f914fa40e673485eb@o442018.ingest.us.sentry.io/5878552',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      ignore: [
        'iframe[src*="clarity.ms"]',
        'iframe[src*="google-analytics.com"]',
        'iframe[src*="googleadservices.com"]',
        'iframe[src*="google.com/ccm."]',
      ],
    }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
